export const environment = {
    appVersion: '2.1.10',
    recaptcha: {
     siteKey: '6LeaW7gqAAAAADWlIIISbNWY3ADEMSZ9-wrnpW0A',
 },
      production: true,
      baseUrl:'https://tsidev.tsiindia.co.in:8008/inventory/api/'
 };
